import React from "react";
import css from "./Italic.module.css";

const Italic = (props) => {
  return <span className={css.root}>{props.children}</span>;
};

export default Italic;
